//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  data() {
    return {
      collapsed: false,
      selectKey: [2],
      openKey: [1],
      menus: [],
      username: '',
      height: '100%',
      zh_CN,
      user_type:'',
      showTourist: false
    }
  },
  created() {
    const marker = sessionStorage.getItem('marker')
    this.marker = marker

    this.height = window.screen.availHeight - 100
    const cookies = this.$role.showCookies()
    const token = sessionStorage.getItem('token')
    const ratio = sessionStorage.getItem('ratio') ? sessionStorage.getItem('ratio') : 1
    const tourist = sessionStorage.getItem('tourist') == 0  || sessionStorage.getItem('tourist') == null ? 0 : 1
    
    this.tourist = tourist

    if(tourist == 0){
      this.showTourist = true
    }
    else
    {
      this.showTourist = false
    }

    if (!cookies || !token) {
      this.logout()
      //this.$router.push('login')
    } else {
      global.token = token
      global.ratio = ratio
      global.tourist = tourist
      this.$role.saveGlobal(cookies)
      this.user_type = global.type
      this.username = global.userName
      this.menus = this.$role.getRoleMenu()
      this.toggleRouter()
    }
  },
  mounted() {
    this.$nextTick(_ => {
      this.toggleRouter()
    })
  },
  methods: {
    // 给当前路由的导航选中
    toggleRouter() {
      // 设置刷新后重新选中左侧菜单
      let routePath = this.$route.path
      for (var i = 0; i < this.menus.length; i++) {
        let child = this.menus[i].children
        for (var index = 0; index < child.length; index++) {
          if (routePath === child[index].path) {
            if (global.type === 1 && child[index].component === 'finance') {
            } else {
              this.openKey = [child[index].menu_id]
              this.selectKey = [child[index].id]
            }
          }
        }
      }
    },
    jumpPath(index, index1) {
      let child = this.menus[index].children[index1]
      // if (child.component === 'finance' && global.type === 1) {
      //   const h = this.$createElement
      //   this.$info({
      //     title: '提示',
      //     content: h('div', {}, [h('p', '要查看' + child.name + '模块，请用代理账户登录哦')]),
      //     onOk() {}
      //   })
      // } else {
        this.$router.push(child.path)
      //}
    },
    logout() {
      sessionStorage.clear()
      this.$role.saveGlobal()
      this.$role.deleteCookies()
      this.$role.removeRoleMenu()
      localStorage.clear()
      this.$router.push('login')
    },
    open(path) {
      window.open(path)
    }
  },
  watch: {
    $route() {
      // 切换路由时变更背景色
      this.toggleRouter()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/index.vue